import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Grid } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTextInput } from 'components/common/form/text';
import { SelectHitterDataSource } from 'components/common/hitters/select-hitter-data-source';
import { SelectHitterLevel } from 'components/common/hitters/select-hitter-level';
import { SelectHitterRosterStatus } from 'components/common/hitters/select-hitter-roster-status';
import { SelectHitterSide } from 'components/common/hitters/select-hitter-side';
import { RADIX } from 'lib_ts/enums/radix-ui';
import useHittersStore from 'stores/use-hitters-store';

export const HitterLibraryFilters = () => {
  const filters = useHittersStore((s) => s.filters);

  return (
    <ErrorBoundary identifier="HitterLibraryFilters">
      <Grid flexGrow="1" columns="5" gap={RADIX.FLEX.GAP.SM}>
        <CommonTextInput
          id="filter-hitter-name"
          placeholder="common.search-by-name"
          leftSlot={<MagnifyingGlassIcon />}
          value={filters.name}
          debounceMs={300}
          onChange={(v) =>
            useHittersStore.setState((prev) => ({
              filters: {
                ...prev.filters,
                name: v,
              },
            }))
          }
        />
        <SelectHitterSide />
        <SelectHitterLevel />
        <SelectHitterDataSource />
        <SelectHitterRosterStatus />
      </Grid>
    </ErrorBoundary>
  );
};
